const angular = require('angular')
const debounce = require('lodash/debounce')
const map = require('lodash/map')
const previewImage = require('js/infrastructure/previewImage.js')

/* Directives */
module.exports = angular
  .module('hxphone.readDirectives', [])
  .directive('readContact', [
    '$state',
    '$utils',
    'contactService',
    '$rootScope',
    function ($state, $utils, contactService, $rootScope) {
      return {
        replace: false,
        templateUrl: 'contact-item.html',
        scope: {
          'emails': '='
        },
        restrict: 'EA',
        link: function (scope, elem, attr) {
          const contacts = scope.emails
          scope.showall = attr.$attr.showall ? attr.showall : false
          scope.contactClass = attr.contactClass
          scope.contacts = angular.isArray(contacts) ? contacts : [contacts]

          // 显示联系人信息详情
          scope.showContactDetail = function (contact) {
            if ($rootScope.isReadOnly || $rootScope.settings.wechatMiniProgram) return

            const oContact = $utils.$email.parse(contact)
            const contactName = $utils.$email.parseTrueName(contact) || oContact.addr.split('@')[0]
            // 判断该联系人是否已经添加到个人通讯录，如果是的话就跳转到该个人通讯录联系人的详情页
            /** todo: 读信没法确切知道用户 id，导致用户和联系人 email 相同时会混淆 */
            if ($rootScope.settings.featureControl.addressBook.enablePersonal) {
              contactService.searchPabContactByEmail(oContact.addr).then(function (data) {
                if (data.code === 'S_OK' && data.var.length !== 0) {
                  $rootScope.isReadIn = true
                  $state.go('frame.personalContactDetail', { contactid: data.var[0].id })
                } else {
                  $state.go('frame.detail', {
                    contactId: oContact.addr,
                    name: contactName
                  })
                }
              }, function (error) {
                console.log(error)
              })
            } else {
              $state.go('frame.detail', {
                contactId: oContact.addr,
                name: contactName
              })
            }
          }
        }
      }
    }
  ])
  .directive('debounceClick', ['$parse', function($parse) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        const delay = Number(attrs.debounceDelay) || 500
        const fn = $parse(attrs.debounceClick)

        element.on('click', debounce(function(evt) {
          scope.$apply(function() {
            fn(scope, {
              $event: evt
            })
          })
        }, delay, {leading: true, trailing: false}))
      }
    }
  }])
  .directive('handleDisplayScrollBar', [
    '$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, elem, attr) {
          elem.on('click', function (event) {
            // 如果点击的是图片的话，打开单独的图片浏览器
            if (event.target.nodeName === 'IMG') {
              previewImage.start({
                urls: map(elem.find('img'), item => item.src),
                current: event.target.src
              })
            }
          })
        }
      }
    }
  ])
  .directive('compileHtml', ['$compile', function ($compile) {
    return {
      restrict: 'A',
      link: function (scope, ele, attrs) {
        // 取出scope的变量进行监听
        const name = attrs.compileHtml.trim()
        if (!name) return

        scope.$watch(name, function () {
          const html = scope.$eval(attrs.compileHtml)
          ele.html(html)
          $compile(ele.contents())(scope)
        })
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/mail/read/readDirectives.js